import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { TheProblem } from './components/TheProblem';
import { FailedAttempts } from './components/FailedAttempts';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { TargetAudience } from './components/TargetAudience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { FloatingCTA } from './components/FloatingCTA';
import { UrgencyBanner } from './components/UrgencyBanner';
export function App() {
  return <main className="min-h-screen bg-background bg-noise" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <Hero data-id="element-2" />
      <OpeningHook data-id="element-3" />
      <TheProblem data-id="element-4" />
      <FailedAttempts data-id="element-5" />
      <UniqueMechanism data-id="element-6" />
      <WhatYouGet data-id="element-7" />
      <TargetAudience data-id="element-8" />
      <HowItWorks data-id="element-9" />
      <Proof data-id="element-10" />
      <Testimonials data-id="element-11" />
      <FAQ data-id="element-12" />
      <Offer data-id="element-13" />
      <Footer data-id="element-14" />
      <FloatingCTA data-id="element-15" />
      <ExitIntentPopup data-id="element-16" />
    </main>;
}